export const latestAssignment = (sourceId, assignments) => assignments
  .filter((a) => a.sourceId === sourceId)
  .reduce((found, a) => (!found || a.id > found.id ? a : found), null);

// A device can be issued when it is marked active, its most recent assignment has ended and, for
// a temporary checkout, the device has been physically returned. The server applies the same rules.
export const deviceAvailable = (source, assignments) => {
  if ((source.status || 'ACTIVE') !== 'ACTIVE') return false;
  const latest = latestAssignment(source.id, assignments);
  return !latest || (!!latest.endedAt && (latest.mode !== 'TEMPORARY' || !!latest.returnedAt));
};

// Temporary checkouts that have ended while the device is still out, most recent first. Only a
// device's latest assignment counts, and a device marked lost or retired is no longer expected back.
export const awaitingReturn = (assignments, sources = []) => {
  const latest = new Map();
  assignments.forEach((a) => { if (!latest.has(a.sourceId) || a.id > latest.get(a.sourceId).id) latest.set(a.sourceId, a); });
  const writtenOff = new Set(sources.filter((s) => ['LOST', 'RETIRED'].includes(s.status)).map((s) => s.id));
  return [...latest.values()]
    .filter((a) => a.mode === 'TEMPORARY' && a.endedAt && !a.returnedAt && !writtenOff.has(a.sourceId))
    .sort((a, b) => Date.parse(b.endedAt) - Date.parse(a.endedAt));
};

export default deviceAvailable;
